module.exports = __webpack_public_path__ + "img/pending.bb26ff34.svg";